const keyMap = () => {
  return (e, keySettings) => {
    const { selected, setSelected, undo, canUndo, remove } = keySettings
    const kC = e.keyCode

    if (selected) {
      if (kC === 38) {
        // arrow up
        const currentNode = document.querySelector(`[data-selectable-id="${selected}"]`)
        let nextNode = currentNode.previousElementSibling
        if (nextNode === null) {
          nextNode = currentNode.parentNode.lastChild
        }
        const nextNodeId = nextNode.dataset.selectableId
        return nextNodeId === selected ? true : setSelected(nextNodeId);
      }

      else if (kC === 40) {
        // arrow down
        const currentNode = document.querySelector(`[data-selectable-id="${selected}"]`)
        let nextNode = currentNode.nextElementSibling
        if (nextNode === null) {
          nextNode = currentNode.parentNode.firstChild
        }
        const nextNodeId = nextNode.dataset.selectableId
        return nextNodeId === selected ? true : setSelected(nextNodeId);
      }

      else if (kC === 39) {
        // arrow right
        const currentNode = document.querySelector(`[data-selectable-id="${selected}"]`)
        if (currentNode) {
          const insideCurrentNode = currentNode.querySelector("[data-selectable-id]")
          if (insideCurrentNode){
            const nodeId = insideCurrentNode.dataset.selectableId
            setSelected(nodeId);
          } else {
            let currentWrapper = currentNode.parentNode.closest(".wrapper")
            let nextWrapper = currentWrapper.nextElementSibling
            if (nextWrapper === null) {
              nextWrapper = currentWrapper.parentNode.firstChild
            }
            const nodeId = nextWrapper.querySelector("[data-selectable-id]").dataset.selectableId
            return nodeId === selected ? true : setSelected(nodeId);
          }
        }
      }

      else if (kC === 37) {
        // arrow left
        const currentNode = document.querySelector(`[data-selectable-id="${selected}"]`)
        if (currentNode) {
          let nodeId
          let currentWrapper = currentNode.parentNode.closest(".wrapper")
          if (currentWrapper === null) return true

          let prevNode = currentWrapper.previousElementSibling
          if (prevNode === null) {
            nodeId = currentNode.parentNode.closest("[data-selectable-id]").dataset.selectableId
          } else {
            nodeId = prevNode.querySelector("[data-selectable-id]").dataset.selectableId
          }
          setSelected(nodeId);
        }
      }

      else if (kC === 46) {
        remove(selected);
      }

      else if (kC === 27) {
        // unselect by esc
        return null === selected ? true : setSelected(null)
      }

      else if (kC === 90 && e.ctrlKey) {
        // undo changes
        if (canUndo) { undo() } else { return true }
      }

      else {
        // any wrong key if selected
        return true
      }
    }

    else if (kC === 38 || kC === 40) {
      // start selection
      const selectedNode = document.querySelector("[data-selectable-id]");
      const nodeId = selectedNode.dataset.selectableId
      setSelected(nodeId);
    }

    else if (kC === 90 && e.ctrlKey) {
      // back step
      if (canUndo) { undo() } else { return true }
    }

    else {
      // any wrong key if not selected
      return true
    }
  }
}


export default keyMap
